<template>
  <b-navbar :style="{background: config.navbarBackgroundColor}">
    <b-navbar-brand
      :style="{color: config.titleColor, fontSize:config.titleSize, whiteSpace:'normal'}"
    >
      <b-row>
        <b-col cols="12" lg="1" class="text-center">
          <b-img fluid :src="config.logo"></b-img>
        </b-col>
        <b-col cols="12" lg="11" class="text-center m-auto">
          <span>{{config.title}}</span>
        </b-col>
      </b-row>
    </b-navbar-brand>
  </b-navbar>
</template>

<script>
export default {
  name: "customNavbar",
  computed: {
    config: function() {
      return this.$store.getters.layoutConfig;
    }
  },

  data() {
    return {};
  }
};
</script>

<style scoped>
.navbar {
  box-shadow: 0 0 15px black;
}
@media only screen and (min-width: 992px) {
  .text-center {
    text-align: left !important;
  }
}
@media only screen and (max-width: 992px) {
  img {
    max-height: 60px;
    max-width: 100%;
  }
}
</style>


